import React from 'react'

const CocktailPartyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='19'
    viewBox='0 0 18 19'
    fill='none'
    {...props}
  >
    <path
      d='M3.00034 18.9V16.9H8.00034V11.9L0.000335693 2.90002V0.900024H18.0003V2.90002L10.0003 11.9V16.9H15.0003V18.9H3.00034ZM4.45034 4.90002H13.5503L15.3503 2.90002H2.65034L4.45034 4.90002Z'
      fill='currentcolor'
    />
  </svg>
)

export default CocktailPartyIcon
